import {Component, EventEmitter, Output} from '@angular/core';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-chat-not-found',
  standalone: true,
  imports: [AssetVersionPipe],
  templateUrl: './chat-not-found.component.html',
  styleUrl: './chat-not-found.component.scss'
})
export class ChatNotFoundComponent {
  @Output() backToPolaris = new EventEmitter<void>();
}
